<template>
    <div>
        <vs-row>
            <vs-col sm="12" lg="8">
                <h4 class="p-2">Acceso masivo a familiares</h4>
            </vs-col>
        </vs-row>
        <vs-row class="mt-4">
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución
                    </label>
                    <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <template v-if="instituciones.length" autocomplete="off">
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="cicloEscolar" class="labelInput">
                        Ciclo Escolar
                    </label>
                    <vs-select filter :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" :disabled="!ciclosEscolares.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                            Requerido
                        </template>
                        <template v-if="ciclosEscolares.length" autocomplete="off">
                            <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <label for="grupo" class="labelInput">
                    Grupo
                </label>
                <vs-select multiple filter :loading="loadingGrupo" class="aqui pt-0" id="grupo" placeholder="Seleccionar Grupo" :key="grupoId" v-model="grupo" :disabled="!grupos.length" autocomplete="off">
                    <template #message-danger v-if="errorFields.includes('grupo')">
                        Requerido
                    </template>
                    <template v-if="grupos.length" autocomplete="off">
                        <vs-option v-for="option in grupos" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </template>
                    <template v-else>
                        <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                        </vs-option>
                    </template>
                </vs-select>
                <div v-if="grupo !== ''" @click="grupo = ''" class="tache">
                    <i class="far fa-times-circle"></i>
                </div>
            </vs-col>
            <vs-col sm="12" lg="3">
                <label for="grupo" class="labelInput">
                    Estatus de acceso
                </label>
                <vs-select filter class="aqui pt-0" id="grupo" placeholder="Seleccionar estatus de acceso" v-model="estatus">
                    <vs-option label="Con acceso" value="con_acceso">
                        Con acceso
                    </vs-option>
                    <vs-option label="Sin acceso" value="sin_acceso">
                        Sin acceso
                    </vs-option>
                    <vs-option label="Todos" value="todos">
                        Todos
                    </vs-option>
                </vs-select>
                <div v-if="estatus !== ''" @click="grupo = ''" class="tache">
                    <i class="far fa-times-circle"></i>
                </div>
            </vs-col>
            <vs-col sm="12" lg="12">
                <vs-button
                class="ml-auto"
                    @click="sanityForm()"
                >
                    Buscar
                </vs-button>
            </vs-col>
        </vs-row>
        <table-familiares :filtros="filtros" :ejecutar="ejecutar"></table-familiares>
    </div>
</template>

<script>
import accesibilidad from '../../../../api/requests/accesibilidad'
import TableFamiliares from './tabla-acceso-masivo-familiares.vue'
export default {
    data(){
        return{
            activeAccesos: false,
            institucion:'',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            loadingCiclo: false,
            grupo: '',
            grupos: [],
            grupoId: (new Date()).getTime(),
            estatus: '',
            loadingGrupo: false,
            errorFields: [],
            ejecutar: 0,
            filtros: {}
        }
    },
    components:{
        TableFamiliares
    },
    created(){
        this.getInstituciones()
    },
    methods:{
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await accesibilidad.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstituto = false
            }
            catch{

            }
        },
        async getCicloEscolar() {
            if(this.institucion){
                this.cicloEscolar = ''
                this.loadingCiclo = true
                const { data: response } = await accesibilidad.getCiclosEscolares(this.institucion)
                this.ciclosEscolares = response
                this.cicloId = (new Date()).getTime()
                this.loadingCiclo = false
            }
        },
        async getGrupo() {
            if(this.cicloEscolar){
                this.grupo = ''
                this.loadingGrupo = true
                const params = {
                    ciclo_escolar_id: this.cicloEscolar
                }
                const { data: response } = await accesibilidad.getGrupo(this.institucion, params)
                this.grupos = this.getEliminarNameKey(response)
                this.grupoId = (new Date()).getTime()
                this.loadingGrupo = false
            }
        },
        getEliminarNameKey(info){
            const datos = Object.values(info)
            return datos
        },
        sanityForm () {
            this.errorFields = []
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.grupo) {
                this.errorFields.push('grupo')
            }
            
            if (!this.errorFields.length){
                this.filtros = {
                    institucion: this.institucion,
                    cicloEscolar: this.cicloEscolar,
                    grupo: this.grupo,
                    estatus: this.estatus
                }
                return this.ejecutar += 1
            } else {
                return false
            }
        },
    },
    watch:{
        institucion(){
            this.cicloEscolar = ''
            this.grupo = ''
            this.users = []
            this.getCicloEscolar()
        },
        cicloEscolar(){
            this.grupo = ''
            this.users = []
            this.getGrupo()
        },
        grupo(){
            this.users = []
        },
        estatus(){
            this.users = []
        }
    }
}
</script>

<style lang="scss" scoped>

    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>